<div ngbDropdown placement="bottom-right" container="body" (openChange)="isOpened = $event">
  <button class="anchor-button" [class.open]="isOpened" type="button" ngbDropdownToggle i18n>
    <img [hidden]="!leftIconSrc" [src]="leftIconSrc" alt="" />
    <ng-content></ng-content>
    <img [src]="isOpened ? '/assets/icons/white/Chevron Up.svg' : '/assets/icons/white/Chevron Down.svg'" alt="" />
  </button>
  <div ngbDropdownMenu class="dropdown-container">
    <button
      class="ngb-dropdown-item"
      ngbDropdownItem
      *ngFor="let item of dropdownItems"
      (click)="itemSelected.emit(item)">
      {{ item.label }}
    </button>
  </div>
</div>
